<template>
  <div class="project">
    <div
      class="rightbox f-webkit-box f-box-vertical"
      :style="{ bottom: bottomStyle }"
    >
      <div
        class="f-color-59c8ff"
        style="
          position: absolute;
          top: 8px;
          left: -280px;
          padding: 48px 10px 8px 40px;
        "
        id="markerInfo"
      ></div>
      <div class="layui-panel f-p-xxs f-p-b">
        <div class="titlebg f-h-full f-webkit-box f-box-vertical">
          <div
            class="layui-cards-title f-lh-36 f-color-white f-p-l-xlg f-size-18"
            id="idZdxm"
          >
            {{ districtNameAA == "" ? "全县" : districtNameAA }}重大项目概况
          </div>
          <div class="f-pt-t-xlg layui-row f-p-l">
            <div class="layui-col-6 f-p-l-md f-p-t-md f-p-b-sm">
              <div class="zdxmtzgk f-p-l">
                <div class="f-color-64c6e7 f-size-14 f-lh-30">重大项目数</div>
                <div>
                  <span
                    class="f-color-ffdc72 f-size-50 f-lh-60 f-figure f-m-r-sm"
                    >{{ xiangMuGaiKuang.projectNum }}</span
                  >
                  <span class="f-color-white f-size-14">个</span>
                </div>
              </div>
            </div>
            <div class="layui-col-6 f-p-l-md f-p-t-md f-p-b-sm">
              <div class="zdxmtzgk f-p-l">
                <div class="f-color-64c6e7 f-size-14 f-lh-30">计划投资</div>
                <div>
                  <span
                    class="f-color-ffc926 f-size-50 f-lh-60 f-figure f-m-r-sm"
                    >{{ xiangMuGaiKuang.planInvest }}</span
                  >
                  <span class="f-color-white f-size-14">万元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="f-pt-t-xlg layui-row f-p-l">
            <div class="layui-col-6 f-p-l-md f-p-t-sm f-p-b-md">
              <div class="zdxmtzgk f-p-l">
                <div class="f-color-64c6e7 f-size-14 f-lh-30">总投资</div>
                <div>
                  <span
                    class="f-color-ffdc72 f-size-50 f-lh-60 f-figure f-m-r-sm"
                    >{{ xiangMuGaiKuang.invest }}</span
                  >
                  <span class="f-color-white f-size-14">万元</span>
                </div>
              </div>
            </div>
            <div class="layui-col-6 f-p-l-md f-p-t-sm f-p-b-md">
              <div class="zdxmtzgk f-p-l">
                <div class="f-color-64c6e7 f-size-14 f-lh-30">已完成投资</div>
                <div>
                  <span
                    class="f-color-ff9226 f-size-50 f-lh-60 f-figure f-m-r-sm"
                    >{{ xiangMuGaiKuang.completedInvest }}</span
                  >
                  <span class="f-color-white f-size-14">万元</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="f-m-t f-m-b-xs layui-panel f-p-xxs"
        id="midlebox"
        v-show="midleboxShow"
      >
        <div class="titlebg f-h-full f-webkit-box f-box-vertical">
          <div
            class="layui-cards-title f-lh-36 f-color-white f-p-l-xlg f-size-18"
          >
            项目进度情况
          </div>
          <div class="f-h-260">
            <div class="layui-carousel f-bg-n" id="test1">
              <el-carousel height="250px" :arrow="arrow">
                <div carousel-item>
                  <el-carousel-item
                    v-for="(item, index) in xiangMuJinDu"
                    :key="index"
                  >
                    <div class="f-p-t f-p-b f-p-l-md f-p-r-md">
                      <ul>
                        <li
                          class="layui-row f-lh-40"
                          v-for="(itemA, ind) in item"
                          :key="ind"
                        >
                          <div
                            class="layui-col-10 f-color-64c6e7 f-size-14"
                            style="
                              overflow: hidden;
                              text-overflow: ellipsis;
                              white-space: nowrap;
                            "
                          >
                            {{ itemA.rank }}
                            {{ itemA.name }}
                          </div>
                          <div class="layui-col-2 f-color-f8f220 f-size-14">
                            {{ itemA.state }}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </el-carousel-item>
                </div>
              </el-carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="legend f-p f-inline-block short f-absolute f-pt-l-n f-pt-b-n"
      style="z-index: 9"
    >
      <span class="f-lh-40">
        <i class="f-color-44cef6 iconfont f-size-40 f-left">&#xe699;</i>
        <span class="f-color-64c6e7 f-size-16 f-left f-p-r">重大项目数</span>
      </span>
      <span class="f-lh-40">
        <i class="f-color-f8f220 iconfont f-size-40 f-left">&#xe699;</i>
        <span class="f-color-64c6e7 f-size-16 f-left f-p-r"
          >进度异常项目数</span
        >
      </span>
    </div>
    <div
      class="legend f-p-t f-p-b long f-absolute f-pt-l-n f-pt-b-n"
      style="right: 630px; z-index: 9"
      v-show="longShow"
    >
      <div class="f-webkit-box">
        <div class="f-p-l f-b-r f-b-color-4974b1 f-box-flex1 f-relative">
          <div class="f-color-white f-p-b-xs f-size-14">项目性质</div>
          <ul class="layui-row">
            <li
              class="legendlist f-color-white layui-row"
              v-for="(item, index) in xiangMuXingZhi"
              :key="index"
            >
              <div class="f-w-30">
                <div
                  class="f-w-16 f-h-16 f-b f-b-color-c8361f f-gradient-r-c8361f f-m-t-xls"
                ></div>
              </div>
              <div class="f-w-70 f-size-14 f-color-64c6e7">{{ item.name }}</div>
              <div class="f-size-18 f-figure f-p-r-xmd">{{ item.count }}</div>
            </li>
          </ul>
        </div>
        <div class="f-b-r f-b-color-4974b1 f-p-l f-box-flex1">
          <div class="f-color-white f-p-b-xs f-size-14">项目规模</div>
          <ul class="layui-row layui-form">
            <el-checkbox-group
              v-model="checkedItem"
              @change="handleCheckedItemsChange"
            >
              <el-checkbox
                v-for="(item, index) in checkList"
                :label="item"
                :key="index"
                disabled
              >
                <div
                  class="f-w-84 f-size-14 f-color-64c6e7"
                  style="display: inline-block; padding-right: 3px"
                >
                  {{ item.name }}
                </div>
                <div
                  class="f-size-18 f-figure f-p-r-xmd"
                  style="color: #fff; display: inline-block"
                >
                  {{ item.count }}
                </div>
              </el-checkbox>
            </el-checkbox-group>
          </ul>
        </div>
        <div
          class="f-webkit-box f-box-vertical f-box-align-c f-box-pack-c f-w-200"
        >
          <div class="f-lh-30">
            <i class="iconfont f-color-f8f220 f-m-r">&#xe6c4;</i>
            <span class="f-color-white f-size-14">未计划开工</span>
          </div>
          <div class="f-lh-30">
            <i class="iconfont f-color-f86220 f-m-r">&#xe6c4;</i>
            <span class="f-color-white f-size-14">未计划竣工</span>
          </div>
        </div>
      </div>
    </div>

    <div class="f-full f-oh f-relative" id="mapid1" style="z-index: 0"></div>
  </div>
</template>

<script>
import Bus from "../bus.js";
import BMap from "BMap";
import { mapGetters } from "vuex";
export default {
  name: "project",
  data() {
    return {
      area: "",
      arrow: "never",
      bottomStyle: "inherit",
      midleboxShow: false,
      footboxShow: false,
      longShow: false,
      checkedItem: [],
      checkList: [],
      xiangMuGaiKuang: {},
      xiangMuJinDu: [],
      xiangMuXingZhi: {},
      xiangMuGuiMo: {},
      districtNameAA: "",
      baseNum: 1,
      bigNum: 2,
    };
  },
  components: {},
  computed: {
    ...mapGetters({
      seatList: "getAreaLists",
    }),
  },
  mounted() {
    this.getData(this.districtNameAA);
    this.getMapZoom();
  },
  methods: {
    getData(name) {
      //项目概况
      this.$axios
        .get("/business/monitor/project/selectMajorProjectsOverview", {
          params: {
            districtName: name,
          },
        })
        .then((res) => {
          this.xiangMuGaiKuang = res.data.data;
        });
      //项目进度
      this.$axios
        .get("/business/monitor/project/selectProjectDisplayScroll", {
          params: {
            num: 20,
          },
        })
        .then((res) => {
          this.xiangMuJinDu = res.data.data;
        });
      //项目分类数目
      this.$axios
        .get("/business/monitor/project/selectProjectsMsg", {
          params: {
            districtName: name,
          },
        })
        .then((res) => {
          this.xiangMuXingZhi = res.data.data.项目性质;
          this.xiangMuGuiMo = res.data.data.项目规模;
          this.checkList = res.data.data.项目规模;
        });
    },

    handleCheckedItemsChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.checkList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.checkList.length;
    },

    getMapZoom() {
      this.$axios
        .get("/business/mapSite/selectByType?type=projectMap")
        .then((res) => {
          this.baseNum = res.data.data.baseNum;
          this.bigNum = res.data.data.bigNum;
          this.getMap(this.baseNum, this.bigNum);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getMap(baseNum, bigNum) {
      console.log(baseNum);
      console.log(bigNum);
      var that = this;
      var parkAreaNo;
      var map = new BMap.Map("mapid1"); // 创建Map实例
      map.centerAndZoom(new BMap.Point(0, 0), 4); // 初始化地图,设置中心点坐标和地图级别

      //   normal 默认地图样式
      //   light 清新蓝风格
      //   dark 黑夜风格
      //   redalert 红色警戒风格
      //   googlelite 精简风格
      //   grassgreen 自然绿风格
      //   midnight  午夜蓝风格
      //   pink 浪漫粉风格
      //   darkgreen 青春绿风格
      //   bluish 清新蓝绿风格
      //   grayscale 高端灰风格
      //   hardedge 强边界风格
      var mapStyle = {
        features: ["road", "building", "water", "land"], //隐藏地图上的poi
        style: "midnight", //设置地图风格为高端黑
      };
      map.setMapStyle(mapStyle);
      // var myStyleJson = [
      //   {
      //     featureType: "land",
      //     elementType: "geometry.fill",
      //     stylers: {
      //       color: "#3d85c6ff",
      //       hue: "#000000",
      //       lightness: -100,
      //       saturation: -100,
      //     },
      //   },
      // ];
      // map.setMapStyle({ styleJson: myStyleJson });
      map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
      var x = that.getUrlParam("x");
      var y = that.getUrlParam("y");
      var z = that.getUrlParam("z") || baseNum;
      map.addEventListener("mousemove", function (e) {
        x = e.point.lng;
        y = e.point.lat;
      });
      map.addEventListener("zoomend", function (e) {
        z = map.getZoom();
        that.$axios.jsonp = (url) => {
          if (!url) {
            console.error("请传入一个url参数");
            return;
          }
          return new Promise((resolve, reject) => {
            window.jsonCallBack = (result) => {
              resolve(result);
            };
            var JSONP = document.createElement("script");
            JSONP.type = "text/javascript";
            JSONP.src = `${url}&callback=jsonCallBack`;
            document.getElementsByTagName("head")[0].appendChild(JSONP);
            setTimeout(() => {
              document.getElementsByTagName("head")[0].removeChild(JSONP);
            }, 500);
          });
        };
        if (z > baseNum) {
          if (z > bigNum) {
            that.$axios
              .jsonp(
                "http://api.map.baidu.com/geocoder/v2/?ak=kZKnwNVIVCP7g9BQGrhS1fSyl6XKoMx0&location=" +
                  y +
                  "," +
                  x +
                  "&output=json&pois=1&callback=BMap._rd._cbk43398"
              )
              .then(function (res) {
                var result = res.result.addressComponent;
                parkAreaNo = result.adcode;
                map.centerAndZoom(new BMap.Point(x, y), z);
                // map.clearOverlays();
                // that.setThirdMarker(parkAreaNo, map);
              });
          } else {
            that.$axios
              .jsonp(
                "http://api.map.baidu.com/geocoder/v2/?ak=kZKnwNVIVCP7g9BQGrhS1fSyl6XKoMx0&location=" +
                  y +
                  "," +
                  x +
                  "&output=json&pois=1&callback=BMap._rd._cbk43398"
              )
              .then(function (res) {
                var result = res.result.addressComponent;
                parkAreaNo = result.adcode;
                that.districtNameAA = result.district;

                that.bottomStyle = 0;
                that.midleboxShow = true;
                that.footboxShow = true;
                that.longShow = true;

                map.centerAndZoom(new BMap.Point(x, y), z);
                map.clearOverlays();
                that.getData(that.districtNameAA);
              });
          }
        } else {
          that.getData("");
          that.districtNameAA = "";
          that.bottomStyle = "inherit";
          that.midleboxShow = false;
          that.footboxShow = false;
          that.longShow = false;

          map.clearOverlays();
          that.$axios
            .get("/business/monitor/project/selectProjectNum")
            .then((result) => {
              var resArr = result.data.data;
              var parkAA = resArr.filter((item) => {
                return (
                  item.code !== "000000" &&
                  item.code !== that.seatList[0].parentCode
                );
              });
              that.$axios
                .get(`/system/config/selectRegionAndVersion`)
                .then((result) => {
                  if (result.data.data.region && result.data.data.version) {
                    that.$axios
                      .get(
                        `/system/config/selectConfigByRegionAndKeyAndVersion?region=${result.data.data.region}&key=json.url&version=${result.data.data.version}`
                      )
                      .then((result) => {
                        var url = `${result.data.data.value}${that.seatList[0].parentCode}.json`;

                        that.$http.get(url).then((result) => {
                          map.centerAndZoom(
                            new BMap.Point(
                              result.body.features[0].properties.center[0],
                              result.body.features[0].properties.center[1]
                            ),
                            z
                          );
                          var arr = result.body.features;
                          //绘制行政区划
                          var bdary = new BMap.Boundary();
                          //循环建立标注点
                          for (var i = 0; i < arr.length; i++) {
                            that.getBoundary(
                              arr[i].properties.name,
                              bdary,
                              map
                            );
                            var x = arr[i].properties.center[0];
                            var y = arr[i].properties.center[1];
                            var no = arr[i].properties.adcode;
                            var point = new BMap.Point(x, y); //将标注点转化成地图上的点
                            var marker = new BMap.Marker(point); //将点转化成标注点
                            marker.name = parkAA[i].name;
                            marker.parkAreaNo = no;
                            marker.x = x;
                            marker.y = y;
                            // marker.count = i + 5;

                            for (var j = 0; j < parkAA.length; j++) {
                              if (parkAA[j].code == arr[i].properties.adcode) {
                                marker.name = parkAA[j].name;
                                marker.count = parkAA[j].count;
                              }
                            }
                            map.addOverlay(marker); //将标注点添加到地图上
                            var sContent =
                              '<div class="f-info-c f-w-70 f-h-70 f-r-o f-color-white f-bg-499cbb f-relative f-webkit-box f-box-align-c f-box-pack-c f-box-vertical">' +
                              '<span class="f-size-26 f-figure f-lh-26">' +
                              marker.count +
                              "</span>" +
                              '<p class="f-color-white f-info-c f-size-16">' +
                              marker.name +
                              "</p>" +
                              '<div class="f-w-22 f-hlh-22 f-r-o f-bg-ffff00 f-absolute f-figure f-size-16 f-pt-t-n f-pt-r-n f-color-000">' +
                              0 +
                              "</div>" +
                              "</div>";

                            var label = new BMap.Label(sContent, {
                              offset: new BMap.Size(-10, -8),
                            });
                            label.setStyle({
                              backgroundColor: "0", //文本标注背景颜色
                              border: "0",
                              fontWeight: "bold", //字体加粗
                            });

                            label.addEventListener("click", function () {
                              map.centerAndZoom(new BMap.Point(x, y), bigNum);
                              map.setZoom(bigNum);
                              var allOverlay = map.getOverlays();
                            });

                            marker.setLabel(label);
                            var markers = [];
                            markers.push(marker);
                          }

                          for (let i = 0; i < markers.length; i++) {
                            (function () {
                              markers[i].addEventListener("click", function () {
                                map.centerAndZoom(new BMap.Point(x, y), bigNum);
                                map.setZoom(bigNum);
                              });
                            })();
                          }
                        });
                      });
                  } else {
                    return;
                  }
                });
            });
        }
      });
      that.$axios
        .get("/business/monitor/project/selectProjectNum")
        .then((result) => {
          var resArr = result.data.data;
          var parkAA = resArr.filter((item) => {
            return (
              item.code !== "000000" &&
              item.code !== that.seatList[0].parentCode
            );
          });
          that.$axios
            .get(`/system/config/selectRegionAndVersion`)
            .then((result) => {
              if (result.data.data.region && result.data.data.version) {
                that.$axios
                  .get(
                    `/system/config/selectConfigByRegionAndKeyAndVersion?region=${result.data.data.region}&key=json.url&version=${result.data.data.version}`
                  )
                  .then((result) => {
                    var url = `${result.data.data.value}${that.seatList[0].parentCode}.json`;
                    that.$http.get(url).then((result) => {
                      map.centerAndZoom(
                        new BMap.Point(
                          result.data.features[0].properties.center[0],
                          result.data.features[0].properties.center[1]
                        ),
                        z
                      );
                      var arr = result.data.features;
                      //绘制行政区划
                      var bdary = new BMap.Boundary();
                      //循环建立标注点
                      for (var i = 0; i < arr.length; i++) {
                        that.getBoundary(parkAA[i].name, bdary, map);
                        var x = arr[i].properties.center[0];
                        var y = arr[i].properties.center[1];
                        var no = arr[i].properties.adcode;
                        var point = new BMap.Point(x, y); //将标注点转化成地图上的点
                        var marker = new BMap.Marker(point); //将点转化成标注点
                        marker.name = parkAA[i].name;
                        marker.parkAreaNo = no;
                        marker.x = x;
                        marker.y = y;
                        for (var j = 0; j < parkAA.length; j++) {
                          if (parkAA[j].code == arr[i].properties.adcode) {
                            marker.name = parkAA[j].name;
                            marker.count = parkAA[j].count;
                          }
                        }

                        map.addOverlay(marker); //将标注点添加到地图上
                        var sContent =
                          '<div class="f-info-c f-w-70 f-h-70 f-r-o f-color-white f-bg-499cbb f-relative f-webkit-box f-box-align-c f-box-pack-c f-box-vertical">' +
                          '<span class="f-size-26 f-figure f-lh-26">' +
                          marker.count +
                          "</span>" +
                          '<p class="f-color-white f-info-c f-size-16">' +
                          marker.name +
                          "</p>" +
                          '<div class="f-w-22 f-hlh-22 f-r-o f-bg-ffff00 f-absolute f-figure f-size-16 f-pt-t-n f-pt-r-n f-color-000">' +
                          0 +
                          "</div>" +
                          "</div>";
                        var label = new BMap.Label(sContent, {
                          offset: new BMap.Size(-10, -8),
                        });
                        label.setStyle({
                          backgroundColor: "0", //文本标注背景颜色
                          border: "0",
                          fontWeight: "bold", //字体加粗
                        });

                        label.addEventListener("click", function () {
                          map.centerAndZoom(new BMap.Point(x, y), bigNum);
                          map.setZoom(bigNum);
                        });

                        marker.setLabel(label);
                        var markers = [];
                        markers.push(marker);
                      }

                      for (let i = 0; i < markers.length; i++) {
                        (function () {
                          markers[i].addEventListener("click", function () {
                            map.centerAndZoom(new BMap.Point(x, y), bigNum);
                            map.setZoom(bigNum);
                          });
                        })();
                      }
                    });
                  });
              } else {
                return;
              }
            });
        });
    },

    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
      var r = window.location.search.substr(1).match(reg); //匹配目标参数
      if (r != null) return decodeURIComponent(r[2]);
      return null; //返回参数值
    },

    getBoundary(data, bdary, map) {
      bdary.get(data, function (rs) {
        //获取行政区域
        var count = rs.boundaries.length; //行政区域的点有多少个
        var pointArray = [];
        for (var i = 0; i < count; i++) {
          var ply = new BMap.Polygon(rs.boundaries[i], {
            strokeWeight: 2,
            strokeColor: "#01b1ed",
          }); //建立多边形覆盖物
          ply.setFillColor("none");
          ply.disableMassClear();
          map.addOverlay(ply); //添加覆盖物
        }
      });
    },
  },
};
</script>

<style scoped>
.project {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  padding-top: 80px;
  background: rgba(0, 0, 0, 0);
}

#mapid1 {
  width: 100%;
  height: 100%;
}
</style>